// extracted by mini-css-extract-plugin
export default {"PlainFeature":"vx_a bhh_b"};